var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 24,
    viewBox: "0 0 16 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.192139 14.7188C0.192139 15.5812 0.770466 16.1494 1.68361 16.1494H7.17265V20.8876C7.17265 22.4399 7.822 23.7285 8.07565 23.7285C8.31916 23.7285 8.96851 22.4399 8.96851 20.8876V16.1494H14.4576C15.3707 16.1494 15.949 15.5812 15.949 14.7188C15.949 12.5779 14.2343 10.3153 11.3833 9.28044L11.0485 4.62338C12.5298 3.78126 13.7473 2.82751 14.2749 2.14772C14.5387 1.80276 14.6706 1.45779 14.6706 1.15341C14.6706 0.534505 14.1938 0.0779228 13.4835 0.0779228H2.66778C1.9474 0.0779228 1.48068 0.534505 1.48068 1.15341C1.48068 1.45779 1.60245 1.80276 1.86624 2.14772C2.39384 2.82751 3.61136 3.78126 5.09271 4.62338L4.75787 9.28044C1.90682 10.3153 0.192139 12.5779 0.192139 14.7188Z",
    fill: "#C7C7CC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.765303f956ab8e5279552472d8395e05.svg";
export { ForwardRef as ReactComponent };